import React from "react";
import Parcel from "single-spa-react/parcel";
// eslint-disable-next-line import/no-unresolved
import { SearchApp } from "@gartner/search";

export default class Autocomplete extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <Parcel config={SearchApp} {...this.props} />;
  }
}
